import * as React from "react";
import type { SVGProps } from "react";
const BulletedList02Icon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M7 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M7 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6" clipRule="evenodd" /></svg>;
export default BulletedList02Icon;